import React from 'react';
import {
    onChangeMultiSelect,
    formatSelectValue,
    mapPollingIntervalType,
    formatDate,
} from '@pluto/react-select-mapping';
import {curry} from 'ramda';
import {string, object} from 'prop-types';
import PollingTypeSelect from './PollingTypeSelect';
import PollingTypeDateSelector from './PollingTypeDateSelector';

export const getDailyValues = () => {
    const hours = ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'];
    const minutes = ['00', '15', '30', '45'];
    const dayParts = ['AM', 'PM'];
    const resultedArray = [];
    
    for (const dayPart of dayParts) {
        for (const hour of hours) {
            for (const minute of minutes) {
                resultedArray.push(`${hour}:${minute} ${dayPart}`);
            }
        }
    }
    
    return resultedArray;
};

export const getPollingTypeLabel = (pollingType: any) => pollingType === 'EVERY' ? 'minutes' : '';

export const getIsMulti = (pollingType: any) => pollingType !== 'EVERY';

export const onChangeFeedsLimit = curry((onChange, e) => {
    onChange(e.value);
});

export default function PollingTypeSelectContainer(props: any) {
    const {
        isValidDate,
        pollingIntervalType,
        pollingIntervalValueField,
        feedsLimitField,
    } = props;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const pollingOptions = pollingTypeValues[pollingIntervalType];
    
    if (!pollingIntervalType)
        return null;
    
    const isMulti = getIsMulti(pollingIntervalType);
    const pollingTypeDateOptions = pollingOptions.map(mapPollingIntervalType(pollingIntervalType));
    const onChangeFeedsLimitField = onChangeFeedsLimit(feedsLimitField.input.onChange);
    
    if (pollingIntervalType === 'TEST') {
        const dateValue = formatDate(pollingIntervalValueField.input.value);
        
        return (
            <PollingTypeDateSelector
                isValidDate={isValidDate}
                pollingTypeDateOptions={pollingTypeDateOptions}
                pollingIntervalValueField={pollingIntervalValueField}
                feedsLimitField={feedsLimitField}
                dateValue={dateValue}
                onChangeFeedsLimitField={onChangeFeedsLimitField}
            />
        );
    }
    const onChangePollingTypeSelect = onChangeMultiSelect({
        onFieldChange: pollingIntervalValueField.input.onChange,
        isMulti,
        isPolling: true,
    });
    const pollingTypeOptions = pollingOptions.map(mapPollingIntervalType(pollingIntervalType));
    const pollingTypeLabel = getPollingTypeLabel(pollingIntervalType);
    const pollingTypeValue = formatSelectValue({
        isMulti,
        pollingIntervalType,
        value: pollingIntervalValueField.input.value,
    });
    
    return (
        <PollingTypeSelect
            pollingTypeLabel={pollingTypeLabel}
            options={pollingTypeOptions}
            onChange={onChangePollingTypeSelect}
            value={pollingTypeValue}
            isMulti={isMulti}
        />
    );
}

PollingTypeSelectContainer.defaultProps = {
    pollingIntervalType: null,
};

PollingTypeSelectContainer.propTypes = {
    pollingIntervalType: string,
    pollingIntervalValueField: object.isRequired,
    feedsLimitField: object.isRequired,
    isValidDate: object.isRequired,
};

const pollingTypeValues = {
    DAILY: getDailyValues(),
    EVERY: [
        10,
        20,
        30,
        40,
        50,
        60,
    ],
    TEST: [
        5,
        10,
        25,
        50,
        100,
        'ALL',
    ],
};

